export default "__VITE_ASSET__BatyzUwb__"